module.exports = __webpack_public_path__ + "img/avatar-41.fc7218d2.png";